<template>
  <div>
    <c-section v-if="isSection"/>
    <c-post/>
  </div>
</template>

<script>
import CPost from '@/components/CPost'
import CSection from '@/components/CSection'
import { computed, watch } from 'vue'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'

export default {
  name: 'PostView',
  components: {
    CPost,
    CSection
  },
  setup () {
    const route = useRoute()
    const store = useStore()

    const postId = computed(() => route.params.code)
    const isSection = computed(
      () => store.getters.getNavigation.find(item => item.value === postId.value)?.list !== undefined
    )
    const setPost = async code => {
      if (isSection.value) {
        await store.dispatch('setPost', { value: postId.value })
      } else {
        await store.dispatch('setPost', code)
      }
    }

    if (store.getters.getPostIds.indexOf(postId.value) !== -1) {
      watch(postId, setPost)
      setPost(postId.value)
    } else {
      store.commit('setNotFound', true)
    }

    return {
      isSection
    }
  }
}
</script>

<style lang="scss"/>
